import React from "react";
import { useDrop } from "react-dnd";

export default function BottomTarget({ handleBlankDrop }) {
  const [{ hovered }, dropRef] = useDrop({
    accept: "utility",
    drop: (item) => handleBlankDrop(item.index),
    collect: (monitor) => ({
      hovered: !!monitor.isOver(),
    }),
  });
  return (
    <div
      style={{
        borderRadius: 8,
        height: 60,
        backgroundColor: hovered ? "#e0e0e0" : "transparent",
      }}
      ref={dropRef}
    ></div>
  );
}
